import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "content-moment-feed",
  name: "动态发现信息流",
  icon: "动",
  group: "信息流页面",
  description: "读取已发布动态，以双列发现卡片展示图片或视频封面。",
  defaultProps: {
    "title": "动态发现",
    "layoutMode": "DISCOVERY",
    "pageSize": 20,
    "coverRatio": "3:4",
    "showPublisher": true,
    "showMetrics": true
}
}
